<template>
  <el-dialog title="下发采集任务" @close="clickClose" :visible.sync="visible">
    <div class="mt-10px">
      <i class="iconfont icon-bg-play text-[#0082f7] text-18px"></i>
      下发范围
    </div>
    <el-row class="mt-10px" :gutter="20">
      <el-col :span="8">
        <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
          <div class="text-right">
            <el-button size="mini" type="primary">添加</el-button>
          </div>
          <el-tabs class="h-400px" v-model="currentRole">
            <el-tab-pane label="组织">
              <el-tree show-checkbox :props="defaultTreeProps" :data="treeData"></el-tree>
            </el-tab-pane>
            <el-tab-pane label="角色"></el-tab-pane>
            <el-tab-pane label="用户"></el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
      <el-col :span="16">
        <el-table
          :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
          border
          stripe
          height="470px"
        >
          <el-table-column width="80" type="index" label="序号"></el-table-column>
          <el-table-column label="下发维度"></el-table-column>
          <el-table-column label="下发范围"></el-table-column>
          <el-table-column label="操作"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div slot="footer">
      <el-button type="primary" size="small">下发</el-button>
      <el-button @click="clickClose" size="small">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentRole: '',
      treeData: [
        {
          name: 'test',
          children: [
            {
              name: 'test1',
              children: [
                {
                  name: 'test2',
                },
              ],
            },
          ],
        },
      ],
      defaultTreeProps: {
        label: 'name',
        children: 'children',
        isLeaf: 'isLeaf',
      },
    }
  },
  methods: {
    clickClose() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
